function hideShopifySections() {
  const sections = document.querySelectorAll('.shopify-section');

  let startFound = false;
  let endFound = false;

  sections.forEach((section) => {
    if (section.classList.contains('qlf-show-more-start')) {
      startFound = true;
      return;
    }

    if (section.classList.contains('qlf-show-more-end')) {
      endFound = true;
      return;
    }

    if (startFound && !endFound) {
      section.style.display = 'none';
    }
  });
}

hideShopifySections();

function handleShowMoreClick() {
  const hiddenSections = document.querySelectorAll('.shopify-section[style*="display: none"]');
  hiddenSections.forEach((section) => {
    section.style.display = 'block';
  });

  document.querySelector('.show-more-button-wrapper').style.display = 'none';
  document.querySelector('.show-less-button-wrapper').style.display = 'block';
}

function handleShowLessClick() {
  hideShopifySections();

  document.querySelector('.show-less-button-wrapper').style.display = 'none';
  document.querySelector('.show-more-button-wrapper').style.display = 'block';
}
